import { makeStyles } from '@material-ui/core/styles'
import { Grid, Typography } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import employeeDetailsImage from 'src/assets/images/employeeDetailsImage.svg'
import formatDate from 'src/utils/commonMethods/formatDate'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import CloseButton from 'src/components/common/CloseButton'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { getQueryParams } from 'src/utils/commonMethods'

const EmployeeSearchDetails = ({ data, claimsData }) => {
  const classes = useStyles()
  const history = useHistory()
  const params = useParams()
  const { search } = useLocation()
  const queryParams = getQueryParams(search)

  const closeFunction = () => {
    const individualViewId = queryParams.get('individualViewId')

    let url
    if (params?.clientId) {
      url = `/corporate/dashboard/${params?.clientId}/${params?.clientType}/employeeManagement?`
    } else {
      url = '/individual/dashboard/company/employeeManagement?'
    }

    if (individualViewId) {
      url = url + `&individualViewId=${individualViewId}`
    }
    history.push(url)
  }

  return (
    <div className={classes.containerDiv}>
      <CloseButton
        title='Close'
        handleClose={closeFunction}
        classname={classes.clsBtn}
      />
      <Grid container className={classes.gridContainer}>
        <Grid className={classes.empDetailsImg} item>
          <Grid item className={classes.leftMargin}>
            <img src={employeeDetailsImage} />
          </Grid>
        </Grid>
        <Grid item className={classes.firstNameEmpId}>
          <Grid item className={classes.gridItemTitle}>
            <Typography className={classes.industryTypeCssNameEmployee}>
              {data?.firstName}({data?.empId})
            </Typography>
          </Grid>
          <Grid item className={classes.leftMargin}>
            <Typography className={classes.industryTypeCss}>
              {data?.email}
            </Typography>
          </Grid>
          <Grid item className={classes.leftMargin}>
            <Typography className={classes.industryTypeCss}>
              {data?.mobileNumber}
            </Typography>
          </Grid>
        </Grid>
        <Grid item className={classes.commonWidth}>
          <Grid item className={classes.gridItemTitle}>
            <Typography className={classes.providerName}>Gender</Typography>
          </Grid>
          <Grid item className={classes.leftMargin}>
            <Typography className={classes.industryTypeCss}>
              {data?.gender ?? '-'}
            </Typography>
          </Grid>
        </Grid>
        <Grid item className={classes.commonWidth}>
          <Grid item className={classes.gridItemTitle}>
            <Typography className={classes.providerName}>
              Date of birth
            </Typography>
          </Grid>
          <Grid item className={classes.leftMargin}>
            <Typography className={classes.industryTypeCss}>
              {formatDate(data?.dateOfBirth)}
            </Typography>
          </Grid>
        </Grid>
        <Grid item className={classes.commonWidth}>
          <Grid item className={classes.gridItemTitle}>
            <Typography className={classes.providerName}>
              Date of joining
            </Typography>
          </Grid>
          <Grid item className={classes.leftMargin}>
            <Typography className={classes.industryTypeCss}>
              {formatDate(data?.dateOfJoining)}
            </Typography>
          </Grid>
        </Grid>
        <Grid item className={classes.commonWidth}>
          <Grid item className={classes.gridItemTitle}>
            <Typography className={classes.providerName}>Dependants</Typography>
          </Grid>
          <Grid item className={classes.leftMargin}>
            <Typography className={classes.industryTypeCss}>
              {' '}
              {data?.dependents?.length ?? '-'}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <div className={classes.borderDiv} />

      <Grid container className={classes.gridContainer}>
        {' '}
        <Grid item className={classes.rm}>
          <Grid item className={classes.gridItemTitle}>
            <Typography className={classes.providerName}>
              Reporting Manager
            </Typography>
          </Grid>
          <Grid item className={classes.leftMargin}>
            <Typography className={classes.industryTypeCss}>
              {data?.reportingManager ?? '-'}
            </Typography>
            <Typography className={classes.industryTypeCss}>
              {data?.reportingManagerMobile ?? '-'}
            </Typography>
          </Grid>
        </Grid>
        <Grid item className={classes.commonWidth}>
          <Grid item className={classes.gridItemTitle}>
            <Typography className={classes.providerName}>
              Total policies
            </Typography>
          </Grid>
          <Grid item className={classes.commonMargin}>
            <Typography className={classes.industryTypeCss}>
              {data?.policyCount}
            </Typography>
          </Grid>
        </Grid>
        <Grid item className={classes.commonWidth}>
          <Grid item className={classes.gridItemTitle}>
            <Typography className={classes.providerName}>CTC</Typography>
          </Grid>
          <Grid item className={classes.commonMargin}>
            <Typography className={classes.industryTypeCss}>
              {formatToINR(data?.ctc) ?? '-'}
            </Typography>
          </Grid>
        </Grid>
        <Grid item className={classes.commonWidth}>
          <Grid item className={classes.gridItemTitle}>
            <Typography className={classes.providerName}>
              Claimed Amount
            </Typography>
          </Grid>
          <Grid item className={classes.commonMargin}>
            <Typography className={classes.industryTypeCss}>
              {claimsData?.employeeBenefits?.claimAmount ?? '-'}
            </Typography>
          </Grid>
        </Grid>
        <Grid item className={classes.commonWidth}>
          <Grid item className={classes.gridItemTitle}>
            <Typography className={classes.providerName}>
              Modifications
            </Typography>
          </Grid>
          <Grid item className={classes.commonMargin}>
            <Typography className={classes.industryTypeCss}>
              {data?.endorsements?.length ?? '-'}
            </Typography>
          </Grid>
        </Grid>
        <Grid item className={classes.commonWidth}>
          <Grid item className={classes.gridItemTitle}>
            <Typography className={classes.providerName}>Claims</Typography>
          </Grid>
          <Grid item className={classes.commonMargin}>
            <Typography className={classes.industryTypeCss}>
              {' '}
              {claimsData?.employeeBenefits?.length ?? '-'}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

export default EmployeeSearchDetails
const useStyles = makeStyles({
  containerDiv: {
    objectFit: 'contain',
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    backgroundColor: COLORS.WHITE,
    borderRadius: '10px',
    padding: '20px',
    margin: '10px',
    boxShadow: '4px 7px 15px rgba(0, 0, 0, 0.1)',
  },
  clsBtn: {
    position: 'absolute',
    right: '10px',
    top: '10px',
  },
  gridContainer: {
    backgroundColor: COLORS.WHITE,
    display: 'flex',
    // justifyContent: "space-between",
    paddingTop: '20px',
    paddingBottom: '20px',
  },
  borderDiv: {
    border: '1px solid rgba(51, 51, 51, 0.2)',
    paddingLeft: '25px',
    paddingRight: '25px',
  },
  gridItemTitle: {
    marginLeft: '5px',
    paddingTop: '7px',
  },
  industryTypeCssName: {
    lineHeight: '0.9',
    fontSize: '12px',
    color: COLORS.GREY,
  },
  industryTypeCss: {
    lineHeight: '21.08px',
    fontSize: '13px',
    color: COLORS.GREY,
    textAlign: 'left',
    fontWeight: '600',
  },
  industryTypeCssNameEmployee: {
    lineHeight: '21.08px',
    fontSize: '14px',
    color: COLORS.GREY,
    textAlign: 'left',
    fontWeight: '600',
  },
  providerName: {
    lineHeight: '0.9',
    fontSize: '10px',
    color: 'rgba(51, 51, 51, 0.6)',
    fontWeight: '600',
    paddingBottom: '5px',
  },
  crossButton: {
    // position: "absolute",
    // top: "0",
    // right: "0",
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '10px',
    height: '20px',
    backgroundColor: COLORS.WHITE,
  },
  empDetailsImg: {
    width: '8%',
  },
  leftMargin: {
    marginLeft: '5px',
  },
  firstNameEmpId: {
    width: '29%',
  },
  commonWidth: {
    width: '15%',
  },
  rm: {
    width: '21%',
  },
  commonMargin: {
    marginLeft: '15px',
  },
})
